import { Component, OnInit } from '@angular/core';
import { ApplicationBase } from 'src/app/base/application-base';
import { PathHelper } from 'src/app/helpers/path.helper';
import { IWindowContent } from 'src/app/interfaces/os/window-content.interface';
import { WindowsManagerService } from 'src/app/services/os/windows-manager.service';
import { JsLoader } from '../classes/js-loader';
import { VfmService } from 'src/app/services/io/vfm.service';
import { ThemeService } from 'src/app/services/ux/theme.service';

@Component({
  selector: 'app-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends ApplicationBase implements IWindowContent, OnInit {
  currentFile: string = null;
  fileContent = "";

  private download = false;

  private scriptsLoaded = 0;
  private scripts = [
    "https://cdn.jsdelivr.net/npm/marked/marked.min.js"
  ];

  constructor(
    private windowsSv: WindowsManagerService,
    private vfm: VfmService,
    public theme: ThemeService
  ) {
    super();
  }

  ngOnInit(): void {
  }

  get currentFormat() {
    if (this.currentFile && this.currentFile.includes(".")) {
      return PathHelper.getExtension(this.currentFile);
    }

    return null;
  }

  get viewComponent(): "iframe" | "markdown" | "object" | "raw" {
    switch (this.currentFormat) {
      case "pdf":
        return "object";
      case "md":
        return "markdown";
      case "html":
        return "iframe";
      default:
        return "raw";
    }
  }

  get isLoading() {
    return this.scriptsLoaded < this.scripts.length;
  }

  get loadProgress() {
    return Math.round(this.scriptsLoaded * 100 / this.scripts.length);
  }

  private async load() {
    const promises = this.scripts.map(m => JsLoader.loadScript(m));

    if (this.viewComponent === "markdown" || this.viewComponent === "raw") {
      promises.push(new Promise<void>(async (resolve, reject) => {
        this.readFileContent(this.currentFile).then(content => {
          this.fileContent = content;
          resolve();
        }, err => {
          reject(err);
        });
      }));
    }

    for (const promise of promises) {
      await promise;
      ++this.scriptsLoaded;
    }
  }

  start(data: any, windowId: number) {
    let path = "";
    const { args = [] } = data || {};

    for (let i = 0; i < args.length; i++) {
      if (args[i] === "--download") {
        this.download = true;
      }
      else {
        path = args[i];
      }
    }

    if (data.cwd && (data.cwd.startsWith("http://") || data.cwd.startsWith("https://"))) {
      this.download = true;
    }

    if (!this.download && data.cwd) {
      path = PathHelper.join(data.cwd, path);
    }

    this.windowsSv.setTitle(windowId, `Viewer: ${path}`);

    this.currentFile = path;

    if (this.windowsSv.getScreenSize().width > 1024) {
      this.windowsSv.resizeWindow(windowId, 1024, 400);
    }

    this.windowsSv.centerWindow(windowId);

    this.load();
  }

  private async readFileContent(currentFile: string) {
    if (this.download) {
      const request = await fetch(currentFile);
      return await request.text();
    }
    else {
      return await this.vfm.readTextFile(currentFile);
    }
  }
}
